import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const securityTrails = defineConnector({
  identifier: "securityTrails",
  name: "SecurityTrails",
  tagLine: "Attack surface and DNS intelligence",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  defaultUrlPattern: () => "https://api\\.securitytrails\\.com/.*",
  auth: (app) => headerAuth([{ name: "APIKEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Open [SecurityTrails account credentials](https://securitytrails.com/app/account/credentials) and create a new API key. SecurityTrails recommends sending it in the `APIKEY` header.",
        },
      ],
    },
    {
      title: "Enter your SecurityTrails API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.securitytrails.com/v1/ips/8.8.8.8/useragents",
  },
});
